import { BUSCAR_CONFIGURACAO_EMPRESA, ATUALIZAR_CONFIGURACAO_EMPRESA } from '../../actions/types';

export default function reducerConfiguracaoEmpresa(state = {}, action) {
    switch (action.type) {
        case BUSCAR_CONFIGURACAO_EMPRESA:
        case ATUALIZAR_CONFIGURACAO_EMPRESA:
            return action.payload.data;
        default:
            return state;
    }
}
